export default function fetchWithHandlingLoginRedirect (url, options = {}) {
  return fetch(url, options)
    .catch(error => {
      window.location.reload()
      return Promise.reject(error)
    })
    .then(response => {
      if (!response.ok) {
        return Promise.reject(response)
      }
      return response.clone().text().then(text => {
        if (text.includes('form role="form" action="/login" method="post')) {
          window.location.reload()
          return Promise.reject(new Error('Session expired. Redirect to login'))
        }
        return response
      })
    })
}
